<template>
    <div id="app">

        <router-view ></router-view >
        <AlbumMood/>
        <HeaderMenu/>

    </div>
    
</template>

<script>
    import $ from 'jquery';
    import AlbumMood from './components/AlbumMood.vue'
    import HeaderMenu from './components/HeaderMenu.vue'

    export default {
        name: 'App',
        data() {
            return {

            };
        },
        created(){
            
        },
        components: {
            HeaderMenu,
            AlbumMood
        },

        mounted() {

           
        }
    }
</script>

<style>



</style>
